import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    ExportButton,
    Datagrid,
    EditButton,
} from 'react-admin';

const ListActions = () => {
    return(
        <TopToolbar>
            {/* Was isAdmin, which showed this button to ROLE_ADMIN while HQ-API held the write to
                super admin and above, so an admin got a create form the POST then refused.
                HQ_Nok::faux_nokkers is the API's own tier, which closes the gap. */}
                <CreateButton />
            {/*<FilterButton />*/}
            <ExportButton />
        </TopToolbar>
    );
}


export const NokEmailSignatureList = () => {

    return (
        <List
            actions={<ListActions/>}
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name" />
                <EditButton />
            </Datagrid>
        </List>
    );
}
